import { FormInput, FormTextEditor } from '@Components/Form';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

const FormInputs = () => {
  const formContext = useForm<{
    name: string;
    description: string;
    address: string;
  }>({
    mode: 'onTouched',
  });

  return (
    <Box>
      <FormProvider {...formContext}>
        <form>
          <Box mt={2}>
            <Typography variant="h3">Form Input</Typography>
            <FormInput
              name="name"
              label="Name"
              fullWidth
              rules={{ required: 'Name is required' }}
            />
            <Typography variant="h3">Form TextEditor</Typography>
            <FormTextEditor
              name="description"
              label="Description"
              inputProps={{
                placeholder: 'พิมพ์อะไรสักอย่างสิ',
              }}
              rules={{ required: 'Description is required' }}
            />
            <Typography variant="h3">Form TextArea</Typography>
            <FormTextAreaAutoSize
              name="address"
              label="Address"
              inputProps={{ minRows: 3, placeholder: 'Please Select address' }}
              rules={{ required: 'address is required' }}
            />
            <Button
              onClick={formContext.handleSubmit((value) => {
                console.log(value);
              })}
              sx={{ mt: 1 }}
            >
              Submit
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  );
};

export default FormInputs;
